export const GdprModal = {
    render() {
        if (document.getElementById('gdprModal')) return;
        const html = `
        <div id="gdprModal" class="modal hidden">
            <div class="modal-content" style="max-width: 600px; padding: 2rem;">
                <div style="width: 100%; display: flex; justify-content: flex-start; margin-bottom: 20px;">
                    <button class="btn-atras-unificado" id="gdpr-close-btn-x">⬅️ ATRÁS</button>
                </div>
                <h2 style="font-size: 1.5rem; margin-bottom: 1rem; color: #1e293b;">🛡️ Política de Privacidad y RGPD</h2>
                <div style="font-size: 0.9rem; color: #475569; text-align: left; max-height: 50vh; overflow-y: auto;">
                    <p><strong>1. Responsable del tratamiento:</strong> Editorial XYZ S.L.</p>
                    <p><strong>2. Finalidad:</strong> Los datos recogidos (nombre del alumno, progreso, tiempos de resolución) se utilizan exclusivamente con fines pedagógicos y para generar informes de progreso para el equipo docente del centro educativo.</p>
                    <p><strong>3. Legitimación:</strong> Consentimiento del centro educativo / padres / tutores legales.</p>
                    <p><strong>4. Destinatarios:</strong> No se cederán datos a terceros salvo obligación legal. Los datos se almacenan de forma segura cumpliendo con el Esquema Nacional de Seguridad.</p>
                    <p><strong>5. Derechos:</strong> Puede ejercer sus derechos de acceso, rectificación, supresión, oposición y portabilidad a través del centro educativo.</p>
                    <p><em>Esta aplicación no utiliza cookies de seguimiento publicitario ni perfiles comerciales. Es un entorno 100% seguro para menores (COPPA & RGPD-K compliant).</em></p>
                </div>
            </div>
        </div>`;
        document.body.insertAdjacentHTML('beforeend', html);
        
        const closeX = document.getElementById('gdpr-close-btn-x');
        if (closeX) closeX.addEventListener('click', () => this.close());
        const closeBtn = document.getElementById('gdpr-close-btn');
        if (closeBtn) closeBtn.addEventListener('click', () => this.close());
    },

    open() {
        this.render();
        document.getElementById('gdprModal').classList.remove('hidden');
    },

    close() {
        const modal = document.getElementById('gdprModal');
        if (modal) modal.classList.add('hidden');
    }
};

if (typeof window !== 'undefined') {
    window.GdprModal = GdprModal;
}
